import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/shopping-cart/components/ShoppingCartInteractive.tsx");
